import { ArrowUpRight, Newspaper } from "lucide-react";

// Media features and press mentions for Dr. Maggie Cadet, MD. Add new entries
// to this list as more articles are gathered.
const PRESS = [
  {
    outlet: "ESSENCE",
    date: "April 2020",
    title: "A Doctor's Advice on COVID-19",
    blurb:
      "Featuring Dr. Cadet's expert guidance on protecting yourself and your family during the COVID-19 pandemic.",
    href: "https://www.essence.com/feature/dr-cadet-expert-coronavirus-covid-19-advice/",
    tag: "COVID-19",
  },
  {
    outlet: "Apple Podcasts",
    date: "2019",
    title: "Lupus Links 2: Dr. Maggie Cadet",
    blurb:
      "A podcast conversation with Dr. Maggie Cadet on lupus, autoimmune disease, and living well.",
    href: "https://podcasts.apple.com/gb/podcast/lupus-links-2-dr-maggie-cadet/id1389629508?i=1000440161022",
    tag: "Podcast",
  },
  {
    outlet: "ESSENCE",
    date: "October 2012",
    title: "No More Knee Pain",
    blurb:
      "Quoted as Director of Rheumatology, Dr. Cadet shares expert guidance on relieving stiff, sore knees, from RICE and OTC options to physical therapy and when to consider surgery.",
    href: "/press/essence-no-more-knee-pain.pdf",
    tag: "Body & Spirit",
  },
  {
    outlet: "ESSENCE",
    date: "April 2020",
    title: "African American Disparities & Coronavirus",
    blurb:
      "Examining why COVID-19 hit African American communities hardest, alongside insights from Dr. Anthony Fauci.",
    href: "https://www.essence.com/news/african-american-disparities-coronavirus-dr-anthony-fauci/",
    tag: "Minority Health",
  },
  {
    outlet: "ESSENCE",
    date: "March 2020",
    title: "New York Clinical Trial: Chloroquine",
    blurb:
      "Inside a New York clinical trial exploring chloroquine as a potential COVID-19 treatment.",
    href: "https://www.essence.com/news/new-york-clinical-trial-coronavirus-chloroquine-d",
    tag: "COVID-19",
  },
  {
    outlet: "CNBC",
    date: "March 2020",
    title: "Regeneron Begins COVID-19 Clinical Trials",
    blurb:
      "Coverage of Regeneron's clinical trials to treat severe COVID-19 symptoms.",
    href: "https://www.cnbc.com/2020/03/18/regeneron-begins-clinical-trials-to-treat-severe-covid-19-symptoms.html",
    tag: "COVID-19",
  },
  {
    outlet: "Healthline",
    date: "March 2020",
    title: "Medical Supply Shortages Under COVID-19",
    blurb:
      "How the pandemic threatened supplies of hydroxychloroquine, a vital medication for people living with lupus.",
    href: "https://www.healthline.com/health-news/medical-supplies-that-will-have-shortages-soon-under-covid-19-outbreak",
    tag: "Lupus",
  },
  {
    outlet: "Medium",
    date: "2020",
    title: "The Plaquenil, COVID-19 & Lupus Connection",
    blurb:
      "Why hydroxychloroquine (Plaquenil) matters for the autoimmune community, and the impact of pandemic shortages.",
    href: "https://medium.com/@marisaleighzeppiericaruana/the-plaquenil-covid-19-lupus-connection-this-drug-saves-lives-im-living-proof-db185ed7c2dd",
    tag: "Lupus",
  },
  {
    outlet: "SingleCare",
    date: "2021",
    title: "Autoimmune Diseases in Women",
    blurb:
      "Why autoimmune diseases disproportionately affect women, and what every woman should know.",
    href: "https://www.singlecare.com/blog/autoimmune-diseases-in-women/",
    tag: "Women's Health",
  },
  {
    outlet: "SingleCare",
    date: "2021",
    title: "Juvenile Arthritis",
    blurb:
      "Understanding juvenile arthritis, its symptoms, diagnosis, and treatment in children.",
    href: "https://www.singlecare.com/blog/juvenile-arthritis/",
    tag: "Arthritis",
  },
  {
    outlet: "Eat This, Not That!",
    date: "2020",
    title: "Hand Sanitizer Mistakes",
    blurb:
      "Common hand-sanitizer mistakes to avoid for better protection during cold, flu, and COVID season.",
    href: "https://www.eatthis.com/hand-sanitizer-mistakes/",
    tag: "Wellness",
  },
  {
    outlet: "Eat This, Not That!",
    date: "2020",
    title: "When to Wear a Face Mask",
    blurb:
      "Expert guidance on when and how to wear a face mask to help limit the spread of illness.",
    href: "https://www.eatthis.com/when-to-wear-face-mask/",
    tag: "Wellness",
  },
  {
    outlet: "The Beautiful Body",
    date: "2020",
    title: "Quarantine Survival: Can Supplements Help?",
    blurb:
      "A look at whether supplements can really support your health and immunity during quarantine.",
    href: "https://thebeautifulbody.com/healthy-living/quarantine-survival-can-supplements-help/",
    tag: "Wellness",
  },
  {
    outlet: "Sweat for Smiles",
    date: "2020",
    title: "Boost Your Immune System",
    blurb:
      "Practical ways to support and boost your immune system through lifestyle and nutrition.",
    href: "https://sweatforsmiles.com/boost-your-immune-system/",
    tag: "Wellness",
  },
  {
    outlet: "Medium",
    date: "2021",
    title: "Dear Doctor: Maggie Cadet",
    blurb:
      "An interview with Dr. Maggie Cadet on her path to medicine, her patients, and her mission.",
    href: "https://medium.com/capsule-cares/dear-doctor-maggie-cadet-a06fa96ce1e3",
    tag: "Interview",
  },
  {
    outlet: "Sleepopolis",
    date: "2023",
    title: "Expert Contributor: Maggie Cadet, MD",
    blurb:
      "Dr. Maggie Cadet lends her expert perspective on sleep, wellness, and healthy living.",
    href: "https://sleepopolis.com/experts/maggie-cadet-md/",
    tag: "Wellness",
  },
  {
    outlet: "The Rheumatologist",
    date: "2015",
    title: "Patients Should Be Proactive, Stay Active",
    blurb:
      "On the importance of staying active and taking an active role in managing rheumatic disease.",
    href: "https://www.the-rheumatologist.org/article/patients-should-be-proactive-stay-active/2/",
    tag: "Arthritis",
  },
  {
    outlet: "EBONY",
    date: "2021",
    title: "Raising Lupus Awareness for Black Men",
    blurb:
      "Highlighting an often-overlooked reality, lupus affects Black men too, and why awareness matters.",
    href: "https://www.ebony.com/lupus-advocate-raises-awareness-for-black-men-with-condition/",
    tag: "Minority Health",
  },
  {
    outlet: "POPSUGAR",
    date: "2020",
    title: "Why Autoimmune Diseases Are So Common in Women",
    blurb:
      "Exploring why women are far more likely than men to develop autoimmune disease.",
    href: "https://www.popsugar.com/fitness/why-are-autoimmune-diseases-so-common-in-women-47614129",
    tag: "Women's Health",
  },
  {
    outlet: "HuffPost",
    date: "2024",
    title: "5 Exercises to Do in the Morning",
    blurb:
      "Experts, including Dr. Cadet, share five exercises worth doing first thing every morning.",
    href: "https://www.huffpost.com/entry/5-exercises-you-should-do-in-the-morning-according-to-experts-goog_l_69fb8445e4b0cb033e4e3c2e",
    tag: "Fitness",
  },
  {
    outlet: "HuffPost",
    date: "2020",
    title: "The Truth About Stress Eating",
    blurb:
      "Why we reach for unhealthy foods under stress, and how to build healthier habits.",
    href: "https://www.huffpost.com/entry/stress-eating-unhealthy-foods_l_5f8efa7dc5b69daf5e16db1e",
    tag: "Wellness",
  },
  {
    outlet: "Health Digest",
    date: "2023",
    title: "Mistakes That Damage Your Joints",
    blurb:
      "Everyday habits that may be quietly harming your joints, and how to protect them.",
    href: "https://www.healthdigest.com/486437/mistakes-that-are-doing-damage-to-your-joints/",
    tag: "Joint Pain",
  },
  {
    outlet: "CreakyJoints",
    date: "2021",
    title: "Don't Delay the COVID-19 Vaccine if Immunocompromised",
    blurb:
      "Guidance for immunocompromised patients on why timely COVID-19 vaccination matters.",
    href: "https://creakyjoints.org/living-with-arthritis/coronavirus/covid-19-vaccines/dont-delay-covid-19-vaccine-immunocompromised/",
    tag: "COVID-19",
  },
  {
    outlet: "CreakyJoints",
    date: "2022",
    title: "Supporting the Immunocompromised Community",
    blurb:
      "Emotional wellness and support for the immunocompromised community through the pandemic.",
    href: "https://creakyjoints.org/living-with-arthritis/coronavirus/emotional-wellness/supporting-immunocompromised-community-during-this-stage-of-covid/",
    tag: "COVID-19",
  },
  {
    outlet: "HealthCentral",
    date: "2021",
    title: "RA's Biggest Emotional Challenges",
    blurb:
      "The emotional side of living with rheumatoid arthritis, and healthy ways to cope.",
    href: "https://www.healthcentral.com/article/rheumatoid-arthritis-biggest-emotional-challenges",
    tag: "Arthritis",
  },
  {
    outlet: "Industry M",
    date: "2022",
    title: "Patient Advocate Spotlight",
    blurb:
      "Dr. Cadet featured for her patient advocacy and community health work.",
    href: "https://industrym.com/patient-advocate/?city=staten%20island",
    tag: "Advocacy",
  },
  {
    outlet: "Future of Personal Health",
    date: "2021",
    title: "The Reality of Battling Lupus Daily",
    blurb:
      "A candid look at what it truly means to live with lupus day to day, and how patients find strength.",
    href: "https://www.futureofpersonalhealth.com/autoimmune-diseases/the-reality-of-battling-lupus-on-a-daily-basis/",
    tag: "Lupus",
  },
  {
    outlet: "Sleepopolis",
    date: "2023",
    title: "A Guide to Psoriasis and Sleep",
    blurb:
      "How psoriasis can disrupt sleep, and expert tips for resting better while living with the condition.",
    href: "https://sleepopolis.com/education/guide-to-psoriasis-and-sleep/",
    tag: "Wellness",
  },
];

// Map each outlet to its website domain; logos are self-hosted in /images/press/<domain>.webp
const OUTLET_DOMAIN = {
  ESSENCE: "essence.com",
  "Apple Podcasts": "apple.com",
  CNBC: "cnbc.com",
  Healthline: "healthline.com",
  Medium: "medium.com",
  SingleCare: "singlecare.com",
  "Eat This, Not That!": "eatthis.com",
  "The Beautiful Body": "thebeautifulbody.com",
  "Sweat for Smiles": "sweatforsmiles.com",
  Sleepopolis: "sleepopolis.com",
  "The Rheumatologist": "the-rheumatologist.org",
  EBONY: "ebony.com",
  POPSUGAR: "popsugar.com",
  HuffPost: "huffpost.com",
  "Health Digest": "healthdigest.com",
  CreakyJoints: "creakyjoints.org",
  HealthCentral: "healthcentral.com",
  "Industry M": "industrym.com",
  "Future of Personal Health": "futureofpersonalhealth.com",
};

export default function Press() {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative py-28 bg-gradient-to-b from-white via-lavender-bg/40 to-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-2xl">
          <p className="pill mb-5 reveal">In the Press</p>
          <h2
            className="h-display text-3xl sm:text-4xl title-underline reveal"
            data-testid="press-title"
          >
            Featured &amp; Quoted
          </h2>
          <p className="mt-7 text-charcoal/80 reveal">
            Dr. Maggie&apos;s expertise in rheumatology, autoimmune disease, and wellness has been
            featured in national media. A selection of features and mentions, with more to come.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-7" data-testid="press-grid">
          {PRESS.map((item, i) => (
            <a
              key={`${item.outlet}-${item.title}`}
              data-testid={`press-card-${i}`}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="card-soft group flex flex-col overflow-hidden scroll-mt-24 transition-transform duration-500 hover:-translate-y-1"
              style={{ animation: `fadeUp .8s ${i * 90}ms both` }}
            >
              <div className="relative h-28 flex items-center justify-center bg-white px-8 border-b border-lavender/40 overflow-hidden">
                <img
                  src={`/images/press/${OUTLET_DOMAIN[item.outlet]}.webp`}
                  alt={`${item.outlet} logo`}
                  loading="lazy"
                  decoding="async"
                  width="48"
                  height="48"
                  className="h-12 w-auto max-w-[75%] object-contain transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 pill bg-lavender-bg/80">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-7">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-display text-lg tracking-[0.28em] uppercase text-plum">
                    {item.outlet}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] tracking-[0.18em] uppercase text-charcoal/75">
                    <Newspaper size={12} /> {item.date}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-[17px] tracking-[0.1em] uppercase leading-snug text-charcoal">
                  {item.title}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-charcoal/75 flex-1">
                  {item.blurb}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-royal group-hover:text-plum transition-colors">
                  Read the article
                  <ArrowUpRight
                    size={15}
                    className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </span>
              </div>
            </a>
          ))}

          {/* Placeholder for upcoming features */}
          <div
            data-testid="press-coming-soon"
            className="rounded-2xl border border-dashed border-lavender/70 bg-white/50 p-7 flex flex-col items-center justify-center text-center reveal"
          >
            <Newspaper size={22} className="text-royal/70" />
            <p className="mt-4 font-display text-[13px] tracking-[0.2em] uppercase text-plum">
              More features coming soon
            </p>
            <p className="mt-2 text-[13px] leading-relaxed text-charcoal/75">
              Additional articles and interviews will be added here.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
